import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BarChart3Icon, ActivityIcon, CreditCardIcon, RepeatIcon, FileTextIcon, DollarSignIcon, ShieldIcon, PieChartIcon, LayoutGridIcon } from 'lucide-react';
export function Reports() {
  const {
    t
  } = useTranslation('analytics');
  const navigate = useNavigate();
  const reportSections = [{
    title: 'Track money movement',
    description: 'Understand the activity in your CIMB account, focused on how activity, fees, and payouts affect your balance.',
    reports: [{
      icon: BarChart3Icon,
      title: 'Balance summary',
      description: 'View your balance and activity summary',
      link: '/balance'
    }
    // Hidden: Activity
    // {
    //   icon: ActivityIcon,
    //   title: 'Activity',
    //   description: 'Track all account activity and transactions',
    //   link: null,
    // },
    // Hidden: Payment fees
    // {
    //   icon: CreditCardIcon,
    //   title: 'Payment fees',
    //   description: 'Analyze payment processing fees',
    //   link: null,
    // },
    // Hidden: Payout reconciliation
    // {
    //   icon: RepeatIcon,
    //   title: 'Payout reconciliation',
    //   description: 'Reconcile payouts with transactions',
    //   link: null,
    // },
    ]
  }, {
    title: 'Custom reports and data analysis',
    description: 'Build custom reports with SQL and AI-assisted natural language prompts.',
    reports: [{
      icon: FileTextIcon,
      title: 'Nadi custom reports',
      description: 'Create custom SQL reports with AI assistance',
      link: '/custom-metrics'
    }]
  }, {
    title: 'Payments analytics',
    description: 'Analyze key metrics and reports about your payments performance.',
    reports: [{
      icon: DollarSignIcon,
      title: 'Acceptance analytics',
      description: 'Track payment acceptance rates',
      link: '/payment-analytics?tab=acceptance'
    }, {
      icon: ShieldIcon,
      title: 'Authentication analytics',
      description: 'Monitor authentication success rates',
      link: '/payment-analytics?tab=authentication'
    }, {
      icon: FileTextIcon,
      title: 'Disputes analytics',
      description: 'Analyze dispute patterns and trends',
      link: '/payment-analytics?tab=disputes'
    }]
  }, {
    title: 'Operational reports',
    description: 'Analyze the operational effectiveness of your CIMB integration, across payments, fraud, and more.',
    reports: [{
      icon: LayoutGridIcon,
      title: 'Card monitoring programs',
      description: 'Track card program performance',
      link: '/card-monitoring'
    }
    // Hidden: Billing analytics
    // {
    //   icon: PieChartIcon,
    //   title: 'Billing analytics',
    //   description: 'Track billing and subscription metrics',
    //   link: null,
    // },
    ]
  }];
  return <div className="max-w-6xl mx-auto" data-id="element-2587" data-mp="3946etr7s4vva">
      <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-2588" data-mp="39350ndvgvt9c">
        {t('pages.Nadi.reports')}
      </h1>

      <div className="space-y-12" data-id="element-2589" data-mp="2cfqq1xchuqj8">
        {reportSections.map((section, sectionIndex) => <div key={sectionIndex} data-id="element-2590" data-mp="2hds6sbmg6drj" data-mpi={sectionIndex}>
            <div className="mb-6" data-id="element-2591" data-mp="2hawcqydq098d">
              <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-2592" data-mp="2lelt50k8rkib">
                {section.title}
              </h2>
              <p className="text-sm text-gray-600 max-w-3xl" data-id="element-2593" data-mp="2q758o32hoppr">
                {section.description}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2594" data-mp="1tlv5hegmj44o">
              {section.reports.map((report, reportIndex) => {
            const Icon = report.icon;
            return <button key={reportIndex} onClick={() => report.link && navigate(report.link)} className="flex items-start gap-3 p-4 bg-white border border-gray-200 rounded-lg hover:border-blue-300 hover:shadow-sm transition-all text-left group" data-id="element-2595" data-mp="19ltn8lu5ykql" data-mpi={reportIndex}>
                    <div className="flex-shrink-0 mt-0.5" data-id="element-2596" data-mp="1xa4hv799no6f">
                      <Icon size={20} className="text-gray-600 group-hover:text-blue-600 transition-colors" data-id="element-2597" data-mp="1sc2wugsa5esb" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-2598" data-mp="22aidfptol5nk">
                      <h3 className="text-sm font-medium text-gray-900 mb-1 group-hover:text-blue-600 transition-colors" data-id="element-2599" data-mp="22as4lgqgpiuu">
                        {report.title}
                      </h3>
                      <p className="text-xs text-gray-600" data-id="element-2600" data-mp="7xj2ia08wzmm">
                        {report.description}
                      </p>
                    </div>
                  </button>;
          })}
            </div>
          </div>)}
      </div>
    </div>;
}